import {
	setUserInteractionDataAttribute,
	TRUST_PILOT_BUSINESS_UNIT_ID,
	TRUST_PILOT_URL,
} from "@shared/constants";
import React, { Component } from "react";

// Copied from:
// https://support.trustpilot.com/hc/en-us/articles/115011421468--Add-a-TrustBox-widget-to-a-single-page-application#add-a-trustbox-widget-with-a-react-application-1

export type TrustPilotTheme = "dark" | "light";
export type TrustPilotWidgetType =
	| "MicroStar" // Used below the lead form step footer on the landing page and in the wizard, shows the stars and "Excellent" text next to them
	| "MicroStarNoTrustScore" // Used in the site header on the landing page, removes the "Excellent" text next to the stars
	| "ReviewsMiniCarousel"; // Used below the lead form in the wizard, shows a mini carousel of reviews

const TrustBox = ({
	height = "24px",
	theme = "light",
	trustBoxRef,
	widgetType = "MicroStar",
	width = "100%",
}: {
	height?: string;
	theme?: TrustPilotTheme;
	trustBoxRef: React.RefObject<HTMLDivElement>;
	widgetType?: TrustPilotWidgetType;
	width?: string;
}) => {
	let reviewLanguages: string = "";
	let tags: string = "";
	let templateId: string; // Default to TrustScore template with trust score (i.e. the one with "Excellent" next to the stars)

	switch (widgetType) {
		case "MicroStar":
			templateId = "5419b732fbfb950b10de65e5";
			break;
		case "MicroStarNoTrustScore":
			templateId = "5406e65db0d04a09e042d5fc";
			break;
		case "ReviewsMiniCarousel":
			reviewLanguages = "en";
			tags = "SelectedReview";
			templateId = "539ad0ffdec7e10e686debd7";
			break;
		default:
			templateId = "5419b732fbfb950b10de65e5"; // Default to MicroStar
	}
	return (
		<div
			{...setUserInteractionDataAttribute("trustpilot-widget")}
			ref={trustBoxRef} // We need a reference to this element to load the TrustBox in componentDidMount.
			className="trustpilot-widget"
			data-locale="en-US"
			data-template-id={templateId}
			data-businessunit-id={TRUST_PILOT_BUSINESS_UNIT_ID}
			data-style-height={height}
			data-style-width={width}
			data-tags={tags}
			data-review-languages={reviewLanguages}
			data-theme={theme}
		>
			<a href={TRUST_PILOT_URL} target="_blank" rel="noopener noreferrer">
				Trustpilot
			</a>
		</div>
	);
};

interface TrustBoxContainerProps {
	height?: string;
	theme?: TrustPilotTheme;
	widgetType?: TrustPilotWidgetType;
	width?: string;
}

class TrustBoxContainer extends Component<TrustBoxContainerProps> {
	trustBoxRef: React.RefObject<HTMLDivElement>;
	constructor(props: TrustBoxContainerProps) {
		super(props);
		this.trustBoxRef = React.createRef();
	}
	componentDidMount() {
		// If window.Trustpilot is available it means that we need to load the TrustBox from our ref.
		// If it's not, it means the script you pasted into <head /> isn't loaded just yet.
		// When it is, it will automatically load the TrustBox.
		if (window.Trustpilot) {
			window.Trustpilot.loadFromElement(this.trustBoxRef.current, true);
		}
	}
	render() {
		return (
			<TrustBox
				height={this.props.height}
				theme={this.props.theme}
				trustBoxRef={this.trustBoxRef}
				widgetType={this.props.widgetType}
				width={this.props.width}
			/>
		);
	}
}
export default TrustBoxContainer;
